import styles from "./Signin.module.scss";
import React from "react";
import Form from "react-bootstrap/Form";
import {Link} from "react-router";
import useSignin from "./useSignin";
import {GoogleLoginButton} from "../../../common/GoogleLoginButton";
import {TextLineAround} from "../../../common/TextLineAround";

const Signin = () => {
  const {
    t,
    logingIn,
    handleLogin,
    signInGoogle,
    error,
    passwordResetted,
    email,
    password,
    updateEmail,
    updatePassword
  } = useSignin();

  return <div className={styles.loginContainer}>
    <div className={styles.textContainer}>
      <div className={styles.noAccount}>{t("title_no_account_yet")}</div>

      <Link className={styles.registerBtn} to="/signup">{t("btn_title_create_account")}</Link>
    </div>

    <div className={styles.formContainer}>
      <div className={styles.loginForm}>
        <div className={styles.logo}>
          <img src="/android-chrome-192x192.png" alt="Logo"/>

          Jikiwi
        </div>

        <GoogleLoginButton label={t("btn_signin_with_google")} onClick={signInGoogle}/>

        <TextLineAround>{t("text_or_signin_with_email")}</TextLineAround>

        {error && <div className={styles.error}>{error}</div>}
        {!error && passwordResetted && <div className={styles.passwordResetted}>{t("text_password_resetted")}</div>}

        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-2" controlId="login-email">
            <Form.Control
              type="text"
              name="email"
              value={email}
              onChange={updateEmail}
              placeholder={t("placeholder_email")}
              disabled={logingIn}
            />
          </Form.Group>
          <Form.Group className="mb-2" controlId="login-password">
            <Form.Control
              type="password"
              name="password"
              value={password}
              onChange={updatePassword}
              placeholder={t("placeholder_password")}
              disabled={logingIn}
              autoComplete="on"
            />
          </Form.Group>

          <button className={styles.submitBtn} type="submit" disabled={logingIn}>{t("btn_signin")}</button>
        </Form>

        <div className={styles.forgotPassword}>
          <Link to="/password">{t("link_password_forgotten")}</Link>
        </div>
      </div>
    </div>
  </div>;
};

export default Signin;
